<div *ngFor="let alert of alerts" class="{{ cssClass(alert) }} alert-dismissable">
    {{ alert.message | translate }}
    <a class="close cursor-pointer" (click)="removeAlert(alert)">&times;</a>
</div>
